// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ApiReferenceController from "./api_reference_controller"
application.register("api-reference", ApiReferenceController)

import CardCanvasController from "./card_canvas_controller"
application.register("card-canvas", CardCanvasController)

import CardController from "./card_controller"
application.register("card", CardController)

import ControllerNameController from "./controller_name_controller"
application.register("controller-name", ControllerNameController)

import CreditPricingController from "./credit_pricing_controller"
application.register("credit-pricing", CreditPricingController)

import DismissibleBannerController from "./dismissible_banner_controller"
application.register("dismissible-banner", DismissibleBannerController)

import ListUploadController from "./list_upload_controller"
application.register("list-upload", ListUploadController)

import MergeTagsController from "./merge_tags_controller"
application.register("merge-tags", MergeTagsController)

import NewCardController from "./new_card_controller"
application.register("new-card", NewCardController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PreviewPollController from "./preview_poll_controller"
application.register("preview-poll", PreviewPollController)

import PurchaseConfirmationController from "./purchase_confirmation_controller"
application.register("purchase-confirmation", PurchaseConfirmationController)

import SampleRequestModalController from "./sample_request_modal_controller"
application.register("sample-request-modal", SampleRequestModalController)

import SignupTierPickerController from "./signup_tier_picker_controller"
application.register("signup-tier-picker", SignupTierPickerController)

import TokenHistoryController from "./token_history_controller"
application.register("token-history", TokenHistoryController)

import WebhookTestPreviewController from "./webhook_test_preview_controller"
application.register("webhook-test-preview", WebhookTestPreviewController)
